import { getModuleRights } from "@/helpers/apps";
import { useAppStore } from "@/store/appStore";

interface UseModuleRights {
  can: (type: "view" | "manage", module: ModuleName) => boolean;
}

export type ModuleName =
  | "Users"
  | "Companies"
  | "Roles"
  | "DeviceOverview"
  | "Tags"
  | "ApiTokens"
  | "ConfigTemplates"
  | "DeviceConfigurations"
  | "Docs"
  | "Dashboard"
  | "TeamManagement"
  | "ReportingOverview"
  | "ReportingConfigurations"
  | "ReportConfigurations"
  | "ReportOverview"
  | "ResourceLibrary"
  | "Analytics"
  | "AlertingOverview"
  | "AlertingConfigurations"
  | "Projects"
  | "Fleets"
  | "Databases"
  | "ExternalStorage"
  | "Simulations"
  | "Apps"
  | "Products"
  | "DeviceLicenses"
  | "Licenses"
  | "LogFlow"
  | "Data Explorer"
  | "Unified Namespace"
  | "VisiontekInsights"
  | "VisiontekInspection"
  | "NodeRed"
  | "TestNodeRed"
  | "Logbook"
  | "Configurator"
  | "VisionTekDev"
  | "TestRolesModule1"
  | "TestRolesModule2"
  | "TestRolesModule3"
  | "App Not Visible For EndUserAdmin Module"
  | "TestTraefikLocal"
  | "Oauth2ProxyTraefik"
  | "NewTemplate"
  | "GlobalAccess"
  | "AlertConfigurations"
  | "AlertOverview"
  | "Notifier"
  | "Tessssst"
  | "test-interact-docker"
  | "test-joey"
  | "TestGiles"
  | "Interact";

/**
 * Hook to check module rights for the current user.
 * Unlike getModuleRights, this hook reacts to changes in the loginAnswer state.
 */
export const useModuleRights = (): UseModuleRights => {
  const loginAnswer = useAppStore((state) => state.loginAnswer);

  const can = (type: "view" | "manage", module: ModuleName) => {
    const rights = loginAnswer?.rights || [];
    return !!getModuleRights(module, rights)?.[type];
  };

  return { can };
};
